export default "__VITE_ASSET__afa5f8ba__"